import React, { useCallback } from 'react'
import { Box, Typography, Grid } from '@material-ui/core'

import { PageTitle } from 'Components/PageTitle'

import DMEmptyState from '../../../../Assets/Images/icons/dmEmptyState'
import { CAMPAING_TYPE_PARAM_TO_EMPTY_TITLE } from '../../../../shared/constants'

import { EmptyStateSimpleBtn } from '../CampaignEmptyStateButtons'
import EmptyStateMessage from '../EmptyStateMessage'
import usePosthogAnalyticsEDDM from './hooks/usePosthogAnalyticsEDDM'

const CampaignEmptyStateEDDM = ({
  classes,
  isSelfServeEnabled,
  handleCreateCampaign,
  validRoute,
  enabledChannel,
  route,
  subRoute,
}) => {
  const { emitAnalyticsEvent } = usePosthogAnalyticsEDDM()

  const handleClick = useCallback(async () => {
    await handleCreateCampaign()
    emitAnalyticsEvent()
  }, [handleCreateCampaign])

  return (
    <React.Fragment>
      {!enabledChannel && (
        <EmptyStateMessage title="Sorry, this channel is currently not available to create a campaign in your country." />
      )}
      <Box className={classes.campaignWrapper}>
        <PageTitle className={classes.title}>
          {CAMPAING_TYPE_PARAM_TO_EMPTY_TITLE[subRoute ? subRoute : route]}
        </PageTitle>
        <Grid
          container
          spacing={3}
          justifyContent="space-between"
          alignItems="center"
        >
          <Grid item xs={12} sm={7}>
            <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
              <p className={classes.emptyStateText}>
                Local Direct Mail, also known as EDDM, allows Promofy clients to
                reach local neighborhoods at a fraction of the cost of
                traditional Direct Mail.
              </p>
              <p className={classes.emptyStateText}>
                Simply select the areas you wish to target, design your mail
                pieces, and let us handle the rest.
              </p>
              <p className={classes.emptyStateText}>
                Leveraging the largest printer network in the US (700+
                partners), we commit to print your mail pieces within 50 miles
                of the destination post office and ensure the distribution
                within 2 to 3 business days.
              </p>
            </Box>
            <Box sx={{ display: { xs: 'block', sm: 'none' } }}>
              <p className={classes.emptyStateText}>
                Reach any neighborhood affordably with Every Door Direct Mail.
                Simply choose your target areas and design your mail pieces—we
                guarantee printing within 50 miles of the destination and
                delivery within 2-3 business days.
              </p>
            </Box>
          </Grid>
          <Grid item xs={12} sm={4} className="text-center">
            <DMEmptyState />
          </Grid>
        </Grid>
        {validRoute && enabledChannel && (
          <Box className={classes.btnWrapper}>
            <Typography className={classes.btnTitle}>
              Let's create your first campaign!
            </Typography>
            {isSelfServeEnabled && (
              <EmptyStateSimpleBtn classes={classes} onClick={handleClick} />
            )}
          </Box>
        )}
      </Box>
    </React.Fragment>
  )
}

export default CampaignEmptyStateEDDM
